import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Award, BookOpen, FileText, Plus, Users } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AdminDashboard() {
  const [stats, setStats] = useState({});
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);

  const cards = [
    { icon: Users, label: "Students", value: stats.students, tint: "royal" },
    { icon: BookOpen, label: "Courses", value: stats.courses, tint: "gold" },
    { icon: FileText, label: "Assignments", value: stats.assignments, tint: "royal" },
    { icon: Award, label: "Certificates", value: stats.certificates, tint: "gold" },
  ];

  return (
    <div className="space-y-6" data-testid="admin-dashboard">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {cards.map((c) => (
          <div key={c.label} className="rounded-3xl bg-card border border-border p-5 card-hover">
            <div className={`h-10 w-10 rounded-xl flex items-center justify-center text-white ${c.tint === "gold" ? "gold-gradient" : "royal-gradient"}`}>
              <c.icon className="h-5 w-5" />
            </div>
            <p className="font-display text-3xl font-bold mt-3">{c.value ?? 0}</p>
            <p className="text-xs text-muted-foreground uppercase tracking-widest mt-1">{c.label}</p>
          </div>
        ))}
      </div>

      <div className="rounded-3xl bg-card border border-border p-6">
        <h2 className="font-display text-xl font-bold">Quick actions</h2>
        <p className="text-sm text-muted-foreground mt-1">Get started managing your platform.</p>
        <div className="mt-5 flex flex-wrap gap-3">
          <Link to="/app/admin/courses/new">
            <Button data-testid="quick-add-course" className="rounded-full royal-gradient border-0 text-white btn-lift">
              <Plus className="h-4 w-4 mr-1.5" /> Add a course
            </Button>
          </Link>
          <Link to="/app/admin/courses">
            <Button variant="outline" className="rounded-full">Manage courses</Button>
          </Link>
          <Link to="/app/admin/announcements">
            <Button variant="outline" className="rounded-full">Send announcement</Button>
          </Link>
          <Link to="/app/admin/live">
            <Button variant="outline" className="rounded-full">Schedule live class</Button>
          </Link>
          <Link to="/app/admin/backup">
            <Button variant="outline" className="rounded-full" data-testid="quick-backup">Backup / Export</Button>
          </Link>
        </div>
      </div>

      <div className="rounded-3xl border border-gold/30 bg-gold/5 p-6">
        <p className="text-xs uppercase tracking-widest text-gold font-semibold">Zero-code workflow</p>
        <h3 className="font-display text-xl font-bold mt-1.5">You never need to touch the code</h3>
        <ul className="mt-3 text-sm text-muted-foreground space-y-1.5 list-disc pl-5">
          <li>Add / edit / delete courses from <b>Courses</b>.</li>
          <li>Open a course to add modules, add lessons (paste YouTube unlisted URLs) and drag to reorder.</li>
          <li>Upload thumbnails directly. Publish or unpublish with one click.</li>
          <li>Post announcements, schedule Zoom live classes, review assignments — all here.</li>
        </ul>
      </div>
    </div>
  );
}
